import React from 'react';
import { 
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
} from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';

function AddUrlDialog({ open, onClose, formData, formErrors, isAdding, onChange, onSubmit }) {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <LanguageIcon />
        Add URL
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <TextField
            fullWidth
            label="Name"
            value={formData.name}
            onChange={onChange('name')}
            placeholder="Enter document name"
            error={!!formErrors.name}
            helperText={formErrors.name}
            sx={{ mb: 3 }}
            disabled={!!formData.fromTemplateKey}
          />
          <TextField
            fullWidth
            label="URL"
            value={formData.url}
            onChange={onChange('url')}
            placeholder="https://example.com"
            error={!!formErrors.url}
            helperText={formErrors.url}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button 
          onClick={onSubmit} 
          variant="contained"
          disabled={isAdding}
          sx={{
            backgroundColor: '#374151',
            color: '#ffffff',
            '&:hover': { 
              backgroundColor: '#1f2937'
            }
          }}
        >
          {isAdding ? 'Adding...' : 'Add URL'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddUrlDialog;
